function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import { instanceOf } from 'prop-types';
import WebClient from "./WebClient.js";
import Context from "./Context.js";
export default function Auth0Provider(props) {
  const {
    client
  } = props;
  const [authenticated, setAuthenticated] = useState(client.isAuthenticated());
  const [error, setError] = useState();
  const [authenticating, setAuthenticating] = useState(false);

  function logout(logoutProps) {
    setAuthenticated(false);
    client.logout(logoutProps);
  }

  async function authenticate() {
    try {
      setError(undefined);
      setAuthenticating(true);
      await client.authenticate();
      setAuthenticated(client.isAuthenticated());
    } catch (err) {
      setError(err);
    } finally {
      setAuthenticating(false);
    }
  }

  return /*#__PURE__*/React.createElement(Context.Provider, _extends({
    value: {
      login: client.login,
      logout,
      authenticate,
      authenticated,
      authenticating,
      error
    }
  }, props));
}
Auth0Provider.propTypes = {
  client: instanceOf(WebClient).isRequired
};